module.exports = __webpack_public_path__ + "static/software_dev_service-0071baa964695f6d3ac61ee5f1a62a8f.svg";